import useApi from "./useApiRequest";
import { useMutation, useQuery } from "react-query";

export const GetAllClientesList = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/empresas/list`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllClientesListMutation: mutation.mutate,
    };
}

export const GetClientsList = ()  => {
    const api = useApi();
    return useQuery(['list_empresas'], async () => {
        const { data } = await api.get(`/empresas/list`);
        return data;
    }, {
        refetchOnWindowFocus: false,
        retry: false
    });
}